import { Component, OnInit, Inject } from '@angular/core';
import { ContractService } from 'src/app/services/http/business/contract/contract.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { IConfirm } from 'src/app/interfaces/confirm';
import { TranslateService } from '@ngstack/translate';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import * as moment from "jalali-moment";
import { environment } from 'src/environments/environment';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-contract-leaving-job',
  templateUrl: './contract-leaving-job.component.html',
  styleUrls: ['./contract-leaving-job.component.css']
})
export class ContractLeavingJobComponent implements OnInit {

  form: FormGroup;
  param: any;
  errorList: IError[] = [];
  errObject: any;
  errors = new Array();
  maxDate = new Date();
  minDate: any;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private contractService: ContractService,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ContractLeavingJobComponent>) { }

  ngOnInit() {
    this.minDate = new Date(this.data.ContractStartDate);
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      Id: [this.data.Id],
      xLeavingJobDate: [null, Validators.compose([Validators.required])],
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  submit(e: any) {

    let confirm: IConfirm = {
      accept: true,
      message:
        this.translate.get("confirm.setLeavingJobDate", {
          name: '<i style="border-bottom: 1px solid;"><span>(' + this.data.ContractNumber + ')</span> ' + this.data.FirstName + ' ' + this.data.LastName + '</i>'
        }),
        alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "500px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var model: any = {
        Id: this.data.Id,
        xLeavingJobDate: moment
          .from(e.xLeavingJobDate, "en")
          .utc(true)
          .format(environment.dateFormat)
      };
      if (result) {
        this.contractService.setLeavingJobDate(model).subscribe(
          () => {
            this.dialogRef.close();
            this.snackBar.OpenSnackBar(
              this.translate.get("success.setLeavingJobDate"),
              "ok",
              5000,
              SoundEnum.beep
            );
          },
          err => {
            // this.errObject = this.errorService.getError(err);
            // this.param = this.errorService.objectError(this.errObject);
            // this.errors = this.errorService.returnError(err);
            this.errorList = this.errorService.getErrorList(err.error);
          }
        );
      }
    });
  }


}
